"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createEnvironmentLoader = void 0;
var flags_1 = require("../flags");
function createEnvironmentLoader(_a) {
    var loadRuntime = _a.loadRuntime, loadHotBundle = _a.loadHotBundle, environment = _a.environment;
    var isLoaded = false;
    var pending = null;
    return {
        load: function () {
            if (pending) {
                return pending;
            }
            pending = Promise.all([
                environment.runtime
                    ? loadRuntime({
                        url: environment.runtime,
                    })
                    : null,
                // TODO: enable and check/test for web worker
                environment.hot && flags_1.isBrowser
                    ? loadHotBundle({
                        url: environment.hot,
                    })
                    : null,
            ]);
            isLoaded = true;
            return pending;
        },
        isLoaded: function () {
            return isLoaded;
        },
    };
}
exports.createEnvironmentLoader = createEnvironmentLoader;
//# sourceMappingURL=createEnvironmentLoader.js.map